import React from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
// import { GlobalOutlined, TranslationOutlined, MessageOutlined, MessageTwoTone } from '@ant-design/icons';
import "flag-icons/css/flag-icons.min.css";

const LanguageSwitcher = ({
  style,
  size = "middle",
  showLabel = false,
  iconOnly = false,
  theme = "dark",
}) => {
  const { i18n, t, ready } = useTranslation();

  const translate = (key) => {
    return ready ? t(key) : key;
  };

  const languages = [
    {
      value: "en",
      label: "English",
      flag: "us", // ISO 3166-1 alpha-2 country code for flag-icons
    },
    {
      value: "ko",
      label: "한국어",
      flag: "kr", // ISO 3166-1 alpha-2 country code for flag-icons
    },
    {
      value: "vn",
      label: "Tiếng Việt",
      flag: "vn", // ISO 3166-1 alpha-2 country code for flag-icons
    },
  ];

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
  };

  const getCurrentLanguage = () => {
    return i18n.language || "en";
  };

  const formatOptionLabel = (option) => (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <span
        className={`fi fi-${option.flag}`}
        style={{
          width: "16px",
          height: "12px",
          display: "inline-block",
          backgroundSize: "cover",
          borderRadius: "2px",
        }}
      ></span>
      {iconOnly ? <span>{option.flag}</span> : <span>{option.label}</span>}
    </div>
  );

  return (
    <div
      style={{ display: "flex", alignItems: "center", gap: "4px", ...style }}
    >
      {showLabel && (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            color: theme === "dark" ? "rgba(255, 255, 255, 0.85)" : "inherit",
          }}
        >
          {/* <GlobalOutlined /> */}
          {/* <TranslationOutlined /> */}
          {/* <MessageOutlined />  */}
          {/* <MessageTwoTone /> */}
          {iconOnly ? null : translate("language.title")}:
        </span>
      )}
      <Select
        value={getCurrentLanguage()}
        onChange={handleLanguageChange}
        size={size}
        style={{ minWidth: iconOnly ? 70 : 120 }}
        placeholder={translate("language.selectLanguage")}
        optionLabelProp="label"
      >
        {languages.map((lang) => (
          <Select.Option
            key={lang.value}
            value={lang.value}
            label={formatOptionLabel(lang)}
          >
            {formatOptionLabel(lang)}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default LanguageSwitcher;
